import AppPage from "layouts/AppPage";
import { useEffect, useState } from "react";
import { NewIncomingWebhook } from "models/integration/incomingWebhook";
import { useNavbar } from "hooks/useNavbar";
import { Container, Heading } from "@chakra-ui/react";
import NewCredentialsCard from "./NewCredentialsCard";
import ConnectedIntegrations from "./ConnectedIntegrations";
import AdditionalIntegrations from "./AdditionalIntegrations";

export default function CompanyIntegrationsPage() {
  const [newWebhookCredentials, setNewWebhookCredentials] = useState<NewIncomingWebhook | null>(null);
  const { setPageTitle, setBreadcrumbs } = useNavbar();

  useEffect(() => {
    setPageTitle("Integrations");
    setBreadcrumbs([{ name: "Integrations", isCurrentPage: true }]);
  }, [setPageTitle, setBreadcrumbs]);

  return (
    <AppPage>
      <Container maxW="1300px" my="6">
        {newWebhookCredentials && <NewCredentialsCard webhookCredentials={newWebhookCredentials} />}
        <Heading as="h1" size="sm" mb="4" color="fg.default">Integrations</Heading>
        <ConnectedIntegrations mb="4" />
        <AdditionalIntegrations setNewWebhookCredentials={setNewWebhookCredentials} />
      </Container>
    </AppPage>
  );
}
